import { MessageService } from 'primeng/api';
import { ConfiguracoesService } from './../../service/configuracoes.service';
import { Configuracao } from './../../model/configuracao';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-geral',
  templateUrl: './admin-geral.component.html',
  styleUrls: ['./admin-geral.component.css']
})
export class AdminGeralComponent implements OnInit {

  item: Configuracao;
  uploadPercentFundo: Observable<number>;
  uploadPercentTopo: Observable<number>;
  uploadPercentPerfil: Observable<number>;
  uploadPercentFooter: Observable<number>;

  constructor(private service: ConfiguracoesService, private messageService: MessageService) { }

  handleChange(e) {
    this.service.salvar(this.item);
  }

  ngOnInit() {
    this.service.find().subscribe(ret => this.item = ret);
  }

  uploadFileFundo(event, form) {
    const file = event.files[0];
    const task = this.service.upload(file);
    this.uploadPercentFundo = this.service.uploadPercent;
    task.then(ret => {
      this.service.deleteFile(this.item.bg_image.id);
      this.item.bg_image = ret;
      this.service.salvar(this.item);
    });
    form.clear();
  }

  uploadFileTopo(event, form) {
    const file = event.files[0];
    const task = this.service.upload(file);
    this.uploadPercentTopo = this.service.uploadPercent;
    task.then(ret => {
      this.service.deleteFile(this.item.top_image.id);
      this.item.top_image = ret;
      this.service.salvar(this.item);
    });
    form.clear();
  }

  uploadFilePerfil(event, form) {
    const file = event.files[0];
    const task = this.service.upload(file);
    this.uploadPercentPerfil = this.service.uploadPercent;
    task.then(ret => {
      this.service.deleteFile(this.item.perfil_image.id);
      this.item.perfil_image = ret;
      this.service.salvar(this.item);
    });
    form.clear();
  }

  uploadFileFooter(event, form) {
    const file = event.files[0];
    const task = this.service.upload(file);
    this.uploadPercentFooter = this.service.uploadPercent;
    task.then(ret => {
      this.service.deleteFile(this.item.footer_image.id);
      this.item.footer_image = ret;
      this.service.salvar(this.item);
    });
    form.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-geral/admin-geral.component.ts